import { FC } from "react";
import { ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { pl as plDateFns } from "date-fns/locale/pl";
import { theme } from "src/theme/theme";
import { getLanguage } from "src/utils/Languages/LanguageContext";
import SubscriptionBenefitsTable from "./SubscriptionBenefitsTable";

interface Props {
  companyId: string;
  employeeId: string;
}

const SubscriptionBenefitsTab: FC<Props> = ({ companyId, employeeId }) => {
  const language = getLanguage();

  return (
    <ThemeProvider theme={theme({ language })}>
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={language === "pl" ? plDateFns : undefined}
      >
        <SubscriptionBenefitsTable
          key={`${companyId}:${employeeId}`}
          companyId={companyId}
          employeeId={employeeId}
        />
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default SubscriptionBenefitsTab;
